var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.833,
    height: 71.832,
    viewBox: "0 0 71.833 71.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sunny-day",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M104.832,183.46a2.451,2.451,0,0,0-2.451,2.451v6.969a2.451,2.451,0,0,0,4.9,0v-6.969A2.451,2.451,0,0,0,104.832,183.46Z",
    transform: "translate(-68.919 -123.5)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M104.832,11.876a2.451,2.451,0,0,0,2.451-2.451V2.454a2.451,2.451,0,0,0-4.9,0v6.97A2.451,2.451,0,0,0,104.832,11.876Z",
    transform: "translate(-68.919 -0.003)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M35.635,160.432l-4.93,4.927a2.451,2.451,0,0,0,3.466,3.467L39.1,163.9a2.451,2.451,0,1,0-3.466-3.467Z",
    transform: "translate(-20.186 -107.515)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M162.16,39.82a2.444,2.444,0,0,0,1.733-.718l4.929-4.927a2.451,2.451,0,1,0-3.466-3.467l-4.929,4.927a2.451,2.451,0,0,0,1.733,4.185Z",
    transform: "translate(-107.51 -20.189)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M11.872,104.846a2.451,2.451,0,0,0-2.451-2.451H2.451a2.451,2.451,0,1,0,0,4.9H9.421A2.451,2.451,0,0,0,11.872,104.846Z",
    transform: "translate(0 -68.93)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M192.876,102.395H185.9a2.451,2.451,0,0,0,0,4.9h6.973a2.451,2.451,0,0,0,0-4.9Z",
    transform: "translate(-123.494 -68.93)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M35.64,39.1a2.451,2.451,0,0,0,3.466-3.467l-4.927-4.927a2.451,2.451,0,1,0-3.466,3.466Z",
    transform: "translate(-20.191 -20.19)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M163.9,160.432a2.451,2.451,0,1,0-3.467,3.466l4.927,4.927a2.451,2.451,0,0,0,3.467-3.466Z",
    transform: "translate(-107.515 -107.515)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M70.594,51.518A19.079,19.079,0,1,0,89.674,70.6,19.1,19.1,0,0,0,70.594,51.518Zm0,33.256A14.177,14.177,0,1,1,84.772,70.6,14.192,14.192,0,0,1,70.594,84.774Z",
    transform: "translate(-34.679 -34.681)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/Day.c7619b379d8fb6ee6160401ea39c028b.svg";
export { ForwardRef as ReactComponent };